<template>
  <div class="zhongjian2" v-if="typelist">
    <div class="jian2_typelist">
      <div class="type_item" :class="isGao === index ? 'item_gao' : ''" v-for="(i, index) in typelist" :key="index"
        @click="UpdateSkin(index)">
        {{ i.name }}
      </div>
    </div>
    <component :is="typelist[isGao].component"></component>
    <div class="footBei" @click="gobei">粤ICP备2024192087号-1</div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { GetTabgrade } from "@/api";
import { useStore } from "vuex";

const store = useStore();
const isGao = computed(() => {
  return store.state.app.isTab1;
});
const typelist = ref();

onMounted(() => {
  GetTabgrade({ type: 2 })
    .then((res) => {
      typelist.value = res;
    })
    .catch();
});

const gobei = () => {
  window.open('https://beian.miit.gov.cn/#/Integrated/index')
}

const UpdateSkin = (val) => {
  console.log(typelist.value,'isGao');
  
  store.commit("app/SET_ISTAB1", val);
  if (val === 2) {
    const paramObj = {
      pageNum: 1,
      pageSize: 30,
      type: null,
      name: null,
      isHop: true,
      state: 1,
    };
    store.dispatch("app/getHopItem", paramObj);
  }
};
</script>

<style lang="scss" scoped>
.zhongjian2 {
  width: 100vw;
  z-index: 1;

  .jian2_typelist {
    display: flex;
    padding: 3rem 3rem 1rem 3rem;
    font-size: 1.5rem;
    font-weight: 600;
    color: #b0b0b0;
    background: var(--bac-ground);
    transition: opacity 0.3s ease-in-out;

    .type_item {
      cursor: pointer;
      margin: 0 1rem;
    }

    .type_item:hover {
      color: var(--middle2-tab1-textgao);
    }

    .item_gao {
      color: var(--middle2-tab1-textgao);
    }
  }
}

.footBei {
  width: 100vw;
  height: 8vh;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  left: 50%;
  bottom: 1rem;
  color: var(--header-text1);
}
</style>